export default __webpack_public_path__ + "static/media/Expandir.3456b18f.svg";